export default "__VITE_ASSET__757fe97f__"